export enum PotentialReclassificationReasons {
    All = 0,
    Hospitalisation = 2,
    Time = 3
}